type VideoUrls = { mime: string; url: string }[]

const extractVideoUrl = (videoUrls?: VideoUrls) => {
  if (!videoUrls || Object.keys(videoUrls).length === 0) {
    return null
  }

  const videoData =
    videoUrls?.find(({ mime }) => mime === 'application/x-mpegURL') ||
    videoUrls?.find(({ mime }) => mime === 'video/mp4')
  let mime = ''
  let url: string | null = null

  if (!videoData) {
    return null
  }

  mime = videoData.mime
  url = videoData.url

  return {
    mime,
    url
  }
}

export default extractVideoUrl
